<template>
    <div class="modal modal_with_radius" :class="{ 'open_modal': showVideoModal}">
    <div class="modal_overlay modal_overlay_transparent"></div>
    <div class="modal_inner">
        <div class="modal_wrapper ">
            <div class="modal_content modal_1080p">
                <span class="close_icon close_icon_sm" @click="closeVideoModal()">×</span>
                <h2>Video Show</h2>
                <div class="row">
                    <div class="col_12">
                        <div class="upload_content_inner">
                            <div id="video_wrap" >
                                <a role="button" :class="['cursor_pointer play_button', {'d_none': videoPlaying}]" @click.prevent="playVideo()">
                                    <img :src="`${baseUrl}assets/images/play.png`" alt="">
                                </a>
                                <VideoIntro
                                    :videoPlaying="videoPlaying"
                                    :currentPlayerTime="currentPlayerTime"
                                    :player="player"
                                    :videoIntro="video.video_intro"
                                />
                                <div class="player_wrap">
                                    <video id="player" class="video-js vjs-default-skin" controls playsinline> </video>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import VideoIntro from "@/components/shared/VideoIntroComponent.vue";
    export default {
        name:'video-modal',
      components: {VideoIntro},
        emits: ["closeModal"],
        data(){
            return{
                baseUrl: process.env.VUE_APP_BASE,
                btnClose: true,
                videoPlaying: false,
                player: null,
                videoSmilFile: '',
                currentPlayerTime: null
            }
        },
        props:{
            showVideoModal:{
                type: Boolean,
                required: true
            },
            video:{
                type: String,
                required: true
            },
        },
        created() {
            if(this.player) {
                this.player.dispose()
                this.videoPlaying = false;
            }
            if(this.video){
                this.videoSmilFile = this.video.smil ? this.video.smil : this.video
                setTimeout(() => {
                    this.initPlayer()
                }, 100);
            }
        },  
        methods:{
            initPlayer() {
                let self = this;
                setTimeout(()=>{
                    this.player = window.videojs('player',{
                        inactivityTimeout: 0,
                        liveui: true,
                        liveTracker: true,
                        fluid: true,
                        controlBar: {
                            volumePanel: {
                                inline: false,
                                volumeControl: {
                                    vertical: true
                                }
                            }
                        }
                    });

                    this.player.volume(0.5);

                    this.player.ready(function() {
                        self.player.src([
                            {src: self.videoSmilFile, type: 'application/x-mpegURL'}
                        ]);
                        self.player.on('timeupdate', function () {
                            self.currentPlayerTime = Math.floor(self.player.currentTime());
                        });
                        self.player.autoplay(false);
                        self.player.aspectRatio('16:9');
                    });
                }, 100)
            },
            playVideo(){
                if(this.player) {
                    this.player.play()
                    this.videoPlaying = true;
                }
            },
            closeVideoModal(){
                if (this.btnClose) {
                    if(this.player) {
                        this.player.dispose()
                        this.videoPlaying = false;
                    }
                    this.$emit("closeModal");
                }
            },
        }
    }
</script>

<style scoped>
    #video_wrap{
        position: relative;
        background: #000;
    }
    #video_wrap .play_button{
        left: 50%;
        position: absolute;
        z-index: 1;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    #video_wrap .video-js{
        position: relative;
        padding-top: 50%;
        background-color: #000 !important;
    }

    .modal_inner .close_icon{
        position: absolute;
        top: -15px;
        right: -15px;
        overflow: hidden;
        cursor: pointer;
        z-index: 5;
        padding: 0.2rem 0.62rem;
        box-shadow: 0px 4px 24px 0px rgb(34 41 47 / 10%);
        border-radius: 4px;
        background: #fff;
        font-size: 2rem;
        font-weight: 400;
        line-height: 1;
        transition: all 0.3s;
    }
</style>